import React, { Children } from 'react';
import { motion } from 'framer-motion';
const stages = [{
  id: 1,
  icon: '🎯',
  title: 'Before Congress',
  goal: 'Build anticipation'
}, {
  id: 2,
  icon: '🧲',
  title: 'Arrival',
  goal: 'Capture attention'
}, {
  id: 3,
  icon: '🚪',
  title: 'Aisle to Booth',
  goal: 'Nudge curiosity'
}, {
  id: 4,
  icon: '💬',
  title: 'Inside Booth',
  goal: 'Deepen conversation'
}, {
  id: 5,
  icon: '🔁',
  title: 'Post Congress',
  goal: 'Keep momentum'
}];
const container = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0
  }
};
export function SlideOverview() {
  return <div className="h-full w-full bg-[#FDF8F8] text-[#2D2926] p-12 md:p-16 flex flex-col justify-center" data-id="element-560">
      <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="mb-16 text-center" data-id="element-561">
        <h2 className="text-4xl font-bold text-[#2D2926] mb-4" data-id="element-562">
          The Congress Journey
        </h2>
        <p className="text-xl text-[#E60012]" data-id="element-563">
          A comprehensive 5-stage engagement strategy
        </p>
      </motion.div>

      <motion.div className="grid grid-cols-1 md:grid-cols-5 gap-4 items-start relative" variants={container} initial="hidden" animate="show" data-id="element-564">
        <div className="hidden md:block absolute top-8 left-[10%] right-[10%] h-0.5 bg-gradient-to-r from-[#E60012]/30 via-[#FF6B6B]/30 to-[#E60012]/30" data-id="element-565" />

        {stages.map(stage => <motion.div key={stage.id} variants={item} className="relative flex flex-col items-center text-center group" data-id="element-566">
            <div className="w-16 h-16 rounded-full bg-white shadow-lg flex items-center justify-center text-3xl mb-6 border-2 border-transparent group-hover:border-[#FF6B6B] transition-colors duration-300 relative z-10" data-id="element-567">
              {stage.icon}
            </div>
            <h3 className="text-lg font-bold text-[#2D2926] mb-2" data-id="element-568">
              {stage.title}
            </h3>
            <p className="text-sm text-[#E60012] px-2" data-id="element-569">{stage.goal}</p>
          </motion.div>)}
      </motion.div>
    </div>;
}